import actionTypes from './actionTypes'

const desmosActions = {
	initializeDesmosSuccess(data) {
		return {
			type: actionTypes.DESMOS_INITIALIZE_SUCCESS,
			data,
		}
	},
	initializeDesmosError() {
		return {
			type: actionTypes.DESMOS_INITIALIZE_ERROR,
		}
	},
	getResultsSuccess(data) {
		return {
			type: actionTypes.DESMOS_GET_RESULTS_SUCCESS,
			data,
		}
	},
	getResultsError() {
		return {
			type: actionTypes.DESMOS_GET_RESULTS_ERROR,
		}
	},
	cancelDesmos() {
		return {
			type: actionTypes.DESMOS_CANCEL_DESMOS,
		}
	},
	cancelGraphPreview() {
		return {
			type: actionTypes.DESMOS_CANCEL_GRAPH_PREVIEW,
		}
	},
	validationSuccess(text) {
		return {
			type: actionTypes.DESMOS_VALIDATION_SUCCESS,
			text,
		}
	},
	saveDesmosSuccess(redirectUrl) {
		return {
			type: actionTypes.DESMOS_SAVE_DESMOS_SUCCESS,
			redirectUrl,
		}
	},
	saveDesmosError(message) {
		return {
			type: actionTypes.DESMOS_SAVE_DESMOS_ERROR,
			message,
		}
	},
	validationError(message) {
		return {
			type: actionTypes.DESMOS_VALIDATION_ERROR,
			message,
		}
	},
	graphSelected(graphId) {
		return {
			type: actionTypes.DESMOS_GRAPH_SELECTED,
			graphId,
		}
	},
	graphPreview(graphId) {
		return {
			type: actionTypes.DESMOS_GRAPH_PREVIEW_SELECTED,
			graphId,
		}
	},
	editDesmos() {
		return {
			type: actionTypes.DESMOS_EDIT_DESMOS,
		}
	},
	categoryDesmosSelected(categorySelected) {
		return {
			type: actionTypes.DESMOS_CATEGORY_DESMOS_SELECTED,
			categorySelected,
		}
	},
}

export default desmosActions
